<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
        [ngClass]="{backgroundWidth: themeService.theme == 'white-label' || themeService.theme == 'life-file'}">
</header>

<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme == 'white-label' || themeService.theme == 'life-file'}">
    <section class="upload-list-container container">
        <app-steps-header *ngIf="createAccount==false" [step1]="'Add Client'" [step2]="'Add Message'"
            [step3]="'Preview &amp; Send'" [isStep1Active]="true" [isStep2Active]="false" [isStep3Active]="false">
        </app-steps-header>
        <app-steps-header *ngIf="createAccount==true" [step1]="'Add Client'" [step2]="'Review'" [step3]="'Create'"
            [isStep1Active]="true" [isStep2Active]="true" [isStep3Active]="false">
        </app-steps-header>
        <section class="template-section-title">
            <div class="title-container">
                <h1>Zenplans Professional</h1>
            </div>
        </section>

        <section class="upload-professionals-list-container">
            <section class="dynamic-collapse">
                <section class="dynamic-collapse-header invite-container">
                    <h1 class="col">Add clients</h1>
                </section>
                <section class="dynamic-collapse-main">
                    <div class="dynamic-collapse-content">
                        <div class="get-started" *ngIf="!clientsUploaded">
                            <div class="buttons-container">
                                <div class="upload-explanations">Upload client name and email address to get started
                                </div>
                                <div class="upload-template-buttons">
                                    <div class="zp-upload-file">
                                        <div class="inputfile" style="display: none">
                                            <input #uploadLogo type="file" value="Upload"
                                                (change)="onFileChange($event)">
                                        </div>
                                        <div class="upload-list" (click)="uploadLogo.click()">Upload</div>
                                    </div>
                                    <input type="button" value="Get Template" class="get-template"
                                        (click)="downloadTemplate()">
                                </div>
                            </div>
                            <!-- <video width="320" height="240" controls>
                                <source src="" type="video/mp4">
                                <source src="" type="video/ogg">
                                Your browser does not support the video tag.
                            </video> -->
                            <div class="explainer-container">
                                <div class="title-container">
                                    <div class="title-section">How to add clients</div>
                                    <div class="how-works"><img
                                            src="../../../assets/img/{{themeService.theme}}/how-works.svg" alt=""></div>
                                </div>
                                <div>1. Click ‘Get Template’ to download the excel file</div>
                                <div>2. Remove the example information</div>
                                <div>3. Add each client’s name and email to the template, then save</div>
                                <div>4. Click ‘upload’ to import the client details</div>
                                <div>5. Review the upload and then continue to add your message</div>
                            </div>
                        </div>

                        <div class="clients-uploaded" *ngIf="clientsUploaded">
                            <header class="header">
                                <div class="title">
                                    <span class="clients-length">{{data.length}} </span>
                                    <span>client<span *ngIf="data.length > 1">s</span> uploaded</span>
                                </div>
                                <div class="continue">
                                    <ng-container *ngIf="createAccount==false">
                                        <input type="button" value="Continue" class="continue-btn"
                                            (click)="redirectToEmailTemplate()">
                                    </ng-container>
                                    <ng-container *ngIf="createAccount==true">
                                        <input type="button" value="Create Accounts" class="continue-btn"
                                            (click)="createUsers()">
                                    </ng-container>
                                </div>
                            </header>
                            <form #emailForm="ngForm">
                                <table *ngIf="data && data.length > 0" class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Email</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of data; let i = index">
                                            <td *ngIf="editingRowIndex !== i">{{ row.firstName }}</td>
                                            <td class="edited-cell" *ngIf="editingRowIndex === i">
                                                <input class="edited-input" [(ngModel)]="row.firstName"
                                                    name="first_name_{{i}}" required />
                                            </td>
                                            <td *ngIf="editingRowIndex !== i">{{ row.lastName }}</td>
                                            <td class="edited-cell" *ngIf="editingRowIndex === i">
                                                <input class="edited-input" [(ngModel)]="row.lastName"
                                                    name="last_name_{{i}}" required />
                                            </td>
                                            <td *ngIf="editingRowIndex !== i"
                                                [class.invalid]="invalidEmails.includes(i)">{{ row.email }}</td>
                                            <td class="edited-cell" *ngIf="editingRowIndex === i">
                                                <input class="edited-input" [(ngModel)]="row.email" name="email_{{i}}"
                                                    #emailInput="ngModel" [class.invalid]="invalidEmails.includes(i)"
                                                    required email />

                                            </td>
                                            <td class="modif-buttons-container"
                                                [ngClass]="{ 'edited-cell': editingRowIndex === i }">
                                                <button class="modif-button" *ngIf="editingRowIndex !== i"
                                                    (click)="editRow(i)">Edit</button>
                                                <button class="modif-button" *ngIf="editingRowIndex === i"
                                                    (click)="saveRow(i, emailForm)">Save</button>
                                                <button class="modif-button" *ngIf="editingRowIndex === i"
                                                    (click)="cancelEdit()">Cancel</button>
                                                <button class="modif-button" *ngIf="editingRowIndex !== i"
                                                    (click)="deleteRow(i)">Delete</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>
                        </div>
                    </div>
                </section>
            </section>
        </section>
    </section>
</section>